import React from "react";
import { ReactSVG } from "react-svg";

function SearchComponent({ search, searchPlaceholder, searchValue, onchange,onKeyDown, name, value, purpose, inputRef, inputProps }) {

  return <>
    <div className="search-container dashboard-header-search" style={{ width: purpose === "Search Enrolled Students" && "50%",position:'relative',display:'flex',alignItems:'center' }}>
      <ReactSVG style={{position:"absolute",left:'12px',marginBottom:'10px', borderRight: '2px solid #ccc',paddingRight: '7px' }} src={search} />
      <input
              ref={inputRef}
        {...inputProps}

        type="text"
        className="search-input"
        placeholder={searchPlaceholder}
        onChange={onchange}
        onKeyDown={onKeyDown}
        name={name}
        value={value}
        style={{ backgroundColor: purpose === "Search Enrolled Students" && "white", boxShadow: purpose === "Search Enrolled Students" && "0px 1px 9px #dbdbdb",width: '100%', paddingLeft: '50px', boxSizing: 'border-box', borderRadius: '10px', border: '1px solid rgb(204, 204, 204)', height: '36px' }} />
    </div>
  </> 
}
export default SearchComponent;